/**
 * Edited code from: https://github.com/videni/rjsf-antd/blob/master/src/FieldTemplate/FieldTemplate.tsx
 */

import React from 'react';
import { FieldTemplateProps } from '@rjsf/core';
import Form from 'antd/es/form';
import Tooltip from 'antd/es/tooltip';
import Typography from 'antd/es/typography';
import styled from 'styled-components';

export const FieldTemplate = ({
    id,
    children,
    displayLabel,
    rawErrors = [],
    rawHelp,
    rawDescription,
    required,
    schema,
}: FieldTemplateProps) => {
    // simply return children, we don't want an object is wrapped in Form.Item
    // every property should have their own Form.Item wrapper
    if (schema.type === 'object') {
        return <>{children}</>;
    }

    return (
        <Form.Item
            validateStatus={rawErrors.length ? 'error' : ''}
            required={required}
            label={displayLabel && schema.title}
            htmlFor={id}
            id={id}>
            {displayLabel && rawDescription ? (
                <Description>
                    <Tooltip title={rawHelp} overlay={false}>
                        <Typography>{rawDescription}</Typography>
                    </Tooltip>
                </Description>
            ) : null}
            {children}
            {rawErrors.length > 0 &&
                rawErrors.map((error: string, i: number) => {
                    return (
                        <Error key={i}>
                            {displayLabel && schema.title ? <span>'{schema.title}' </span> : null}
                            {error}
                        </Error>
                    );
                })}
        </Form.Item>
    );
};

const Description = styled.span`
    display: inline-block;
    margin-bottom: ${({ theme }) => theme.spacing.xs};
    width: 100%;
    article {
        color: ${({ theme }) => theme.color.N8};
    }
`;

const Error = styled.span`
    color: ${({ theme }) => theme.color.R6};
`;

export default FieldTemplate;
